import Component from '../../../../../ui-components/Component';
import Styles from './styles';
import { withResizer, withTranslations } from '../../../../../HoCs';
import React from 'react';
import view from '../../../../../Enums'
import stageMap from './../../config';
import pages,{ getRouteForPage } from '../../../../../PageEnums';
import { Link } from 'react-router-dom';

class PropertyInformation extends Component {
    
    styles = Styles;
    translation_key = 'properties_translations';

    // onEditClick = () => window.location = '/property_edit/' + this.props.propertyID;

    // onAddListing = () => window.location = '/property_ota_listing/' + this.props.propertyID;
    
    render() {
        return (
            <>
                <div style={this.gs('instruction_box')}>
                    <div style={this.gs('instruction_left')}>{this.gc('things_you_need')}</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                        <div style={this.gs('instruction_title')}>{this.gc('fill_information_about')}</div>
                        </div>
                        <Link
                            to={getRouteForPage(pages.PROPERTIES,'edit',this.props.propertyID)}
                            style={this.gs('action_btn_wrapper')}
                        >
                            <div style={this.gs('action_btn')} className='hover'>{this.gc('edit_details')}</div>
                        </Link>
                    </div>
                </div>
    
                <div style={{...this.gs('instruction_box'),...(this.getViewMode() == view.MOBILE ?{borderBottom:''}:{})}}>
                    <div style={this.gs('instruction_left')}>{this.gc('additional_info')}</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                        <div style={this.gs('instruction_title')}>{this.gc('fill_the_links')}</div>
                        <div style={this.gs('instruction_sub')}>{this.gc('providing_us_your')}</div>
                        </div>
                        <Link
                            to={getRouteForPage(pages.PROPERTIES,'new','ota',this.props.propertyID)}
                            style={this.gs('action_btn_wrapper')}
                        >
                            <div style={this.gs('action_btn')} className='hover' onClick={this.onAddListing}>{this.gc('add_listing')}</div>
                        </Link>
                    </div>
                </div>
            </>
        );
    }
}

export default withResizer(withTranslations(PropertyInformation));